import RouteNames from '../router/route-names';
export { CALCULATION_FREQUENCIES } from 'ecx.saigon.ui.common';

export const ROUTE_BASE = '/core';

export const FEATURES = {
  multiQuote: 'multiQuotes',
  settlement: 'settlement',
  inLife: 'inLife',
  docuSign: 'docuSign',
  inactivityTimeout: 'inactivityTimeout',
  payrollCostCenterEmployer: 'novatedPayrollCostCenterEmployer',
  payrollCostCenterEmployee: 'novatedPayrollCostCenterEmployee'
};

export const DRIVE_QUERY_DELAY = 1000;
export const CATCHE_QUERY_DELAY = 0;

export const LOGIN_THEME = 'novated';
export const GLOBAL_ERROR = 'GLOBAL_ERROR';
export const UNSUPPORTED_BROWSER = 'UNSUPPORTED_BROWSER';
export const APPROVAL_NOT_FOUND = 'APPROVAL_NOT_FOUND';

export const DEFAULT_BRAND = 'fleetPlus';
export const BRAND_DOCUMENTS = {
  //
  fleetPlus: {
    leaseTerms: 'documents/FPartners-lease.pdf',
    novatedServiceAgreement: 'documents/FPartners-novated-service-agreement.pdf'
  },
  fleetPartners: {
    leaseTerms: 'documents/FPartners-lease.pdf',
    novatedServiceAgreement: 'documents/FPartners-novated-service-agreement.pdf'
  },
  fleetChoice: {
    leaseTerms: 'documents/FPartners-lease.pdf',
    novatedServiceAgreement: 'documents/FPartners-novated-service-agreement.pdf'
  }
};

export const NOVATED_INFORMATION_IMG_PATH =
  'images/novated-information-vehicle.svg';
export const GIRL_ON_CAR_PATH = 'images/girl-on-car.png';
export const SIGNING_BACKGROUND_PATH = 'backgrounds/sign-up.jpg';
export const FP_LOGO_PATH = 'logos/novated-white.svg';
export const VEHICLE_ERROR_IMG_PATH = 'images/vehicle-error.svg';
export const CAR_DELIVERED_IMG_PATH = 'images/car-delivered.svg';
export const LEASE_WITHOUT_IMG_PATH = 'images/settlement-no-data.svg';
export const DOCUMENT_SIGNED_IMG_PATH = 'images/document-signed.svg';
export const CLAIM_SUBMITTED_IMG_PATH = 'images/claim-submitted.svg';
export const CLAIM_START_IMG_PATH = 'images/claim-start.svg';
export const PROFILE_SETUP_CONTACT_PATH = 'images/profile-setup-contact.svg';
export const PROFILE_SETUP_POSTCODE_PATH = 'images/profile-setup-postcode.svg';

export const DEFAULT_API_DATE_FORMAT = 'yyyy-MM-ddTHH:mm:ss.SSSZ';

export const PERMISSIONS = {
  HR_APPROVAL: 'SAIGON:HR:APPROVAL'
};

export const DEFAULT_PAGINATION = {
  page: 0,
  size: 25
};

export const PIN_LENGTH = 6;

export const PIN_ERROR_STATUSES = {
  maxAttemptReached: 'maxAttemptReached',
  tokenExpired: 'tokenExpired',
  tokenDidNotMatch: 'tokenDidNotMatch'
};

export const CREATE_USER_STATUSES = {
  userCreated: 'userCreated',
  emailRequiresVerification: 'emailRequiresVerification',
  emailVerified: 'emailVerified'
};

export const HR_APPROVAL_REASONS = {
  notEligible: {
    label: 'Not Eligible for a Novated Lease',
    value: 'notEligible'
  },
  incorrectSalary: {
    label: 'Gross Salary Incorrect',
    value: 'incorrectSalary'
  },
  incorrectAddress: { label: 'Address Incorrect', value: 'incorrectAddress' },
  other: {
    label: 'Other (please add to notes)',
    value: 'other'
  }
};

export const APPLICATION_STATUSES = {
  draft: 'draft',
  complete: 'complete',
  delete: 'delete'
};

export const SETTLEMENT_STATUSES = {
  carDelivered: 'carDelivered'
};

export const QUOTE_STATUSES = {
  DRAFT: {
    value: 'DRAFT',
    label: 'Draft',
    color: 'warning'
  },
  SUBMITTED: {
    value: 'SUBMITTED',
    label: 'Submitted',
    color: 'warning'
  },
  REQUESTED: {
    value: 'requested',
    label: 'Requested',
    color: 'warning'
  },
  AWAITINGPRICING: {
    value: 'AWAITINGPRICING',
    label: 'Awaiting Pricing',
    color: 'warning'
  },
  PRICINGRECEIVED: {
    value: 'PRICINGRECEIVED',
    label: 'Quoted',
    color: 'primary'
  },
  ACCEPTED: {
    value: 'ACCEPTED',
    label: 'Quote Accepted',
    color: 'positive'
  },
  CANCELLED: {
    value: 'CANCELLED',
    label: 'Cancelled',
    color: 'negative'
  }
};

export const CLAIM_STATUSES = {
  Approved: {
    value: 'Approved',
    label: 'Approved'
  },
  InProgress: {
    value: 'InProgress',
    label: 'In Progress'
  },
  OnHold: {
    value: 'OnProgress',
    label: 'On Hold'
  },

  // MILES
  Posted: {
    value: 'Posted',
    label: 'Posted'
  },
  Finalized: {
    value: 'Finalized',
    label: 'Finalized'
  },
  Contested: {
    value: 'Contested',
    label: 'Contested'
  }
};

export const CLAIM_TYPES = {
  fuel: {
    value: 'fuel',
    label: 'Fuel',
    icon: 'icon-budget-fuel-simple'
  },
  fuelElectiricity: {
    value: 'fuel/electricity',
    label: 'Fuel/Electricity - cents per kilometre',
    icon: 'icon-budget-fuel-simple'
  },
  tyres: {
    value: 'tyres',
    label: 'Tyres',
    icon: 'icon-tyre-simple'
  },
  'repair and maintenance': {
    value: 'maintenance',
    label: 'Repair and Maintenance',
    icon: 'icon-budget-maintenance-simple'
  },
  insurance: {
    value: 'insurance',
    label: 'Comprehensive Insurance',
    icon: 'icon-budget-insurance-simple'
  },
  registration: {
    value: 'registration',
    label: 'Registration',
    icon: 'icon-budget-registration-simple'
  },
  ctp: {
    value: 'ctp',
    label: 'CTP',
    icon: 'icon-ctp-simple'
  }
};

export const CLAIM_LIST_TYPES = {
  ...CLAIM_TYPES,
  service: {
    value: 'service',
    label: 'Services and Maintenance',
    icon: 'icon-budget-maintenance-simple'
  }
};

export const DOCUSIGN_ROLE_TYPES = {
  employer: 'employer',
  employee: 'employee'
};

export const DOCUSIGN_DOCUMENT_TYPES = {
  quote: 'quote',
  settlement: 'settlement'
};

export const CLAIM_MAX_FILE_SIZE = 10000000;
export const CLAIM_MAX_FILES = 12;
export const CLAIM_FILE_REQUIREMENTS = {
  accepts: 'image/jpg, image/jpeg, image/png, application/pdf',
  maxFileSize: CLAIM_MAX_FILE_SIZE,
  maxFiles: CLAIM_MAX_FILES,
  maxTotalSize: CLAIM_MAX_FILE_SIZE * CLAIM_MAX_FILES
};

export const HR_APPROVAL_STATUSES = {
  pending: {
    label: 'Pending',
    value: 'pending',
    hrApproval: 'pending'
  },
  approved: {
    label: 'Approved',
    value: 'approved',
    hrApproval: 'approved'
  },
  denied: {
    label: 'Denied',
    value: 'denied',
    hrApproval: 'denied'
  }
};

export const HR_APPROVAL_TYPES = {
  all: {
    label: 'All',
    plural: 'All',
    value: undefined
  },
  quote: {
    label: 'Quote',
    plural: 'Quotes',
    value: 'novated-quote'
  },
  contract: {
    label: 'Contract',
    plural: 'Contracts',
    value: 'novated-contract'
  }
};

export const REQUEST_TYPES_MAPPING = Object.values(HR_APPROVAL_TYPES).reduce(
  (acc, reqType) => {
    if (reqType.value) {
      acc[reqType.value] = reqType.label;
    }

    return acc;
  },
  {}
);

export const MATCHES_ORGANISATIONS_OPTIONS = {
  single: 'single',
  multiple: 'multiple',
  none: 'none'
};

export const USER_PROFILE_PAGES = {
  corporateEmail: 'corporateEmail',
  companyName: 'companyName',
  organisationSelection: 'organisationSelection',
  postcode: 'postcode',
  contactNumber: 'contactNumber'
};

export const USER_PROFILE_PAGE_CONTACT_US = 'contactUs';

export const INITIAL_PAY_TO_DATA = {
  accountName: undefined,
  bsb: undefined,
  accountNumber: undefined
};

export const COMMON_TABS = [
  {
    name: 'dashboard',
    label: 'Home',
    to: { name: RouteNames.dashboard }
  }
];

export const IN_LIFE_TABS = [
  {
    name: 'budgets',
    label: 'Budgets',
    to: { name: RouteNames.budgets }
  },
  {
    name: 'claims',
    label: 'Claims',
    to: { name: RouteNames.claimsLanding }
  }
];

export const HR_APPROVALS_DEFAULT_STATUS = HR_APPROVAL_STATUSES.pending.value;

export const LEASE_TERM_OPTIONS = [
  { text: '1', key: 1 },
  { text: '2', key: 2 },
  { text: '3', key: 3 },
  { text: '4', key: 4 },
  { text: '5', key: 5 }
];

export const VEHICLE_TYPES = {
  SM: {
    name: 'Small',
    icon: 'icon-body-small'
  },
  MS: {
    name: 'Mid-Size',
    icon: 'icon-body-mid-size'
  },
  LR: {
    name: 'Large',
    icon: 'icon-body-large'
  },
  SV: {
    name: 'SUV',
    icon: 'icon-body-suv'
  },
  L4: {
    name: 'Large 4WD',
    icon: 'icon-body-large-4wd'
  },
  LX: {
    name: 'Luxury',
    icon: 'icon-body-luxury'
  },
  SP: {
    name: 'Sports',
    icon: 'icon-body-sports'
  }
};

export const USER_ACCESS_LEVEL = {
  APPLICATION: 'APPLICATION', // User has full basic access
  DASHBOARD: 'DASHBOARD', // User should only have access to the dashboard
  NONE: 'NONE', // User should not go further than the calculator
  CREDIT_ONLY: 'CREDIT_ONLY' // User should only have access post credit check
};

export const VEHICLE_CONDITION_OPTIONS = [
  { text: 'NEW', key: 'new' },
  { text: 'USED', key: 'used' }
];

export const IN_LIFE_CREATE_OPTIONS = {
  CLAIM: {
    key: 'CLAIM',
    label: 'Claim',
    description: 'Make a claim',
    icon: 'icon-create-claim'
  },
  QUOTE: {
    key: 'QUOTE',
    label: 'Quote',
    description: 'Get a new quote',
    icon: 'icon-create-quote'
  }
};

export const IN_LIFE_FOOTER_HELP = {
  icon: 'icon-nav-help',
  label: 'HELP',
  disable: true
};

export const ANNUAL_SALARY_MIN = 0;
export const ANNUAL_SALARY_MAX = 200000;
export const CAR_VALUE_MIN = 10000;
export const CAR_VALUE_MAX = 160000;

export const INITIAL_USER = {
  hasOrganisation: false,
  entity: undefined,
  permissions: [],
  profile: {},
  contactDetails: {},
  features: {},
  accessLevel: undefined
};

export const HR_APPROVAL = {
  id: undefined,
  name: undefined,
  address: undefined,
  payrollNumber: undefined,
  costCenter: undefined,
  erpOrgName: undefined,
  vehicle: {
    modelYear: undefined,
    make: undefined,
    model: undefined,
    variant: undefined
  },
  fbtValue: undefined,
  annualSalary: undefined,
  monthlyRental: undefined,
  nodes: undefined,
  reason: undefined
};

export const INITIAL_APPLICATION = {
  applicationId: undefined,
  applicationStatus: undefined,
  metaData: {
    acceptedQuote: {
      erpQuoteRef: undefined,
      milesQuoteRef: undefined
    },
    quoteId: undefined,
    creditCheckCompleted: false,
    quotes: []
  }
};

export const INITIAL_SETTLEMENT = {
  approximateDelivery: undefined,
  confirmedDelivery: undefined,
  orderId: undefined,
  status: undefined,
  dealer: {
    name: undefined,
    location: undefined
  },
  deliveryMessage: undefined,
  activeLeasesWithoutData: []
};

export const INITIAL_QUOTE = {
  quoteId: undefined,
  erpQuoteRef: undefined,
  status: undefined,
  make: {
    description: undefined
  },
  bodyType: undefined,
  model: {
    name: undefined
  },
  variant: {
    name: undefined,
    gears: undefined,
    doors: undefined,
    modelYear: undefined,
    fuelTankCapacity: undefined,
    transmission: undefined,
    photos: {
      path: undefined
    }
  },
  leaseTerm: undefined,
  kmsPerYear: undefined,
  novated: {
    impactTakeHome: undefined
  },
  exteriorColour: {
    name: undefined
  }
};

export const INITIAL_LEASE = {
  id: undefined,
  ref: undefined,
  savingsGSTThisMonth: undefined, // Used in the list
  savingsToDateGST: undefined, // Used in the list
  savingsToDateTax: undefined, // Used in the list
  currentBalance: undefined, // Used in the list
  vehicleRego: undefined,
  vehicleImg: undefined,
  term: undefined,
  currentMonth: undefined,
  leaseType: undefined,
  leaseActive: undefined,
  carLeaseCost: undefined,
  runningBudgetCost: undefined,
  otherCosts: undefined,
  totalLeaseCost: undefined,
  impactOnTakeHomePay: undefined,
  leaseStartDate: undefined,
  leaseEndDate: undefined,
  leaseAnnualKM: undefined,
  interestRate: undefined,
  financier: undefined,
  residualValue: undefined,
  primaryDocuments: [],
  registrationPaidUntil: undefined,
  vehicleDescription: undefined,
  vehicleVin: undefined,
  insurer: undefined,
  insuranceRenewalDate: undefined,
  allianzDocuments: [],
  otherDocuments: []
};

export const APPROVAL_TYPES = {
  NOVATED_QUOTE: 'novated-quote',
  NOVATED_CONTRACT: 'novated-contract'
};

export const MONTHS_NEAR_EXPIRATION_THRESHOLD = 999;
export const NEW_QUOTE_LEASE_SELECTOR_DIALOG_MAX_WIDTH = 500;

export const USER_ERROR_TYPE = {
  notFound: 'User not found'
}
